export default __webpack_public_path__ + "static/HomepageWomanOnBalcony-mobile-e5500726d77e0ec1f7c2fae9e10200e0.jpg";